import {
  useWSModalCustom,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { ApiKey, ApiKeyWithSecret } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { ErrorAlert } from "@components/ErrorAlert";
import { queriesApiKeys } from "@query";

type Props = {
  apiKey: ApiKey;
} & WSModalCustomProps<ApiKeyWithSecret | null>;

const ModalRotateApiKey: React.FC<Props> = props => {
  const [rotateApiKey, meta] = queriesApiKeys.rotateApiKey.useMutation();

  const handleRotate = async () => {
    await rotateApiKey(
      { apiKeyId: props.apiKey.id },
      { onSuccess: rotated => props.onClose(rotated) }
    );
  };

  return (
    <WSModal
      size="S"
      title={`Rotate ${props.apiKey.name}?`}
      onClose={() => props.onClose(null)}
      actions={{
        buttons: [
          {
            label: "Cancel",
            kind: "Secondary",
            type: "button",
            onClick: () => props.onClose(null)
          },
          {
            label: "Rotate key",
            kind: "Primary",
            destructive: true,
            loading: meta.isLoading,
            onClick: handleRotate
          }
        ]
      }}
    >
      <WSList gap="M">
        <WSText>
          A new secret will be generated and shown once. The current secret will
          stop working immediately, so any integration using it must be updated.
        </WSText>
        <ErrorAlert context="ApiKeyRotate" error={meta.error} />
      </WSList>
    </WSModal>
  );
};

export const useModalRotateApiKey = () => useWSModalCustom(ModalRotateApiKey);
